const CartItemDetails = ({
  description,
}: {
  description: {
    label: string;
    value: React.ReactNode;
    category?: string;
  }[];
}) => {
  const DescriptionItems = ({
    label,
    value,
  }: {
    label: React.ReactNode;
    value: React.ReactNode;
  }) => {
    return (
      <div className="flex gap-1">
        <div className="flex-none text-content-base-subdued">•</div>
        <div>
          <span className="font-semibold text-content-base-subdued">
            {label}:
          </span>{' '}
          <span className="text-content-base-default">{value}</span>
        </div>
      </div>
    );
  };

  const grouped = description.reduce<Record<string, typeof description>>(
    (acc, item) => {
      const key = item.category ?? 'default';
      acc[key] = acc[key] ? [...acc[key], item] : [item];
      return acc;
    },
    {},
  );

  return (
    <div className="flex flex-col gap-2">
      {Object.entries(grouped).map(([category, items]) => (
        <div key={category} className="flex flex-col gap-0.5">
          {category !== 'default' && (
            <div className="mb-0.5 font-semibold text-content-base-default">
              {category}
            </div>
          )}
          {items.map((item, idx) => (
            <DescriptionItems key={idx} label={item.label} value={item.value} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default CartItemDetails;
